export default {"src":"/_next/static/media/error500.d308ac89.svg","height":504,"width":652,"blurWidth":0,"blurHeight":0};